<script>
  // Props
  export let id;
  export let description;
  export let url;

  // Constants
  const IMAGE_HEIGHT = 130;
  const IMAGE_FORMATS = ['avif', 'webp'];
</script>

<picture>
  {#each IMAGE_FORMATS as format}
    <source srcset={`${url}?fm=${format}`} type="image/{format}" />
  {/each}
  <img {id} class="SpotlightImage" loading="lazy" alt={description} src={url} style:height="{IMAGE_HEIGHT}px" />
</picture>

<style>.SpotlightImage {
  border-radius: 6px;
  object-fit: cover;
}</style>
